import {ChangeEvent} from 'react';
import FormLabel from '../../../../../../component/input/FormLabel.component';
import { FormInput, DatePickerComponent } from '../../../../../../component/input/InputStyle';
import { useState } from 'react';
import useDebounce from '../../../../../../hooks/useDebounce';
import {FormInterfaceFilter} from '../../../../../../core/interfaces/form/Form';
import ButtonComponent from '../../../../../../component/buttton/Button.component';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';

export default function FormFilter({handleSubmitForm}: FormInterfaceFilter<any>) {
    const [values, setValues] = useState({
        DataInicio: '',
        DataFim: '',
        Transporte: '',
        Destino: ''
       });

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { value, name } = event.target;
        setValues({ ...values, [name]: value.toUpperCase() });
    }

    const handleChangeDate = (date: Date | string, name: string) => {
      setValues({ ...values, [name]: date });
    }


    return (
        <div style={{display: 'flex', gap:12, alignItems:'flex-end', margin:"18px 0"}}>
            <FormLabel title="Data Inicio" sm={3} md={3} lg={2}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePickerComponent
                      value={values.DataInicio || null}
                      maxDateMessage="data não pode ser maior que Data de Fim"
                      maxDate={values.DataFim || null}
                      onChange={(date: Date | string) => handleChangeDate(date, 'DataInicio')}
                      renderInput={(props: any) => <FormInput {...props} />}
                  />
              </LocalizationProvider>
            </FormLabel>
            <FormLabel title="Data Fim" sm={3} md={3} lg={2}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePickerComponent
                      value={values.DataFim || null}
                      minDate={values.DataInicio || null}
                      maxDateMessage="data não pode ser menor que Data de Inicio"
                      onChange={(date: Date | string) => handleChangeDate(date, 'DataFim')}
                      renderInput={(props: any) => <FormInput {...props} />}
                />
              </LocalizationProvider>
            </FormLabel>
            <FormLabel title="Transporte" sm={3} md={3} lg={2}>
                <FormInput
                    name="Transporte"
                    value={values.Transporte}
                    onChange={handleChange}
                    />
            </FormLabel>
            <FormLabel title="Destino" sm={3} md={3} lg={2}>
                <FormInput
                    name="Destino"
                    value={values.Destino}
                    onChange={handleChange}
                    />
            </FormLabel>
           <ButtonComponent title='Pesquisar' onClick={() => handleSubmitForm(values)} />
            {/* <FormLabel title="Origem" sm={3} md={3} lg={2}>
                <FormInput
                    name="Origem"
                    value={values.Origem}
                    onChange={handleChange}
                    />
            </FormLabel>
            <FormLabel title="Veículo" sm={3} md={3} lg={2}>
                <FormInput
                    name="Veiculo"
                    value={values.Veiculo}
                    onChange={handleChange}
                    />
            </FormLabel>
            <FormLabel title="Remessa" sm={3} md={3} lg={2}>
                <FormInput
                    name="Remessa"
                    value={values.Remessa}
                    onChange={handleChange}
                    />
            </FormLabel> */}
        </div>
    )
}
